import styled from 'styled-components';
import { colors } from '@/styles';

export const SchemaRail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  font-size: 13px;

  & > div {
    margin-bottom: 2px;
  }

  .removed,
  .added,
  .modified {
    border-radius: 2px;
  }
  .removed {
    color: ${colors.semantic.negative.dark};
    background-color: ${colors.semantic.negative.light};
  }
  .added {
    color: ${colors.semantic.positive.dark};
    background-color: ${colors.semantic.positive.light};
  }
  .modified {
    background-color: ${colors.semantic.notice.light};
  }
`;
